import { PICTURE_TYPES } from 'Global/constants'

const originalText = picture => {
  if (picture && picture.source) {
    switch (picture.source) {
      case 'station':
        return 'Orig. Photo Station Picture (JPG)'

      case 'mobile':
        return 'Orig. Mobile Picture (JPG)'

      case 'import':
        return 'Orig. Imported Picture (JPG)'

      case 'designer':
        return 'Orig. Designer Picture (JPG)'

      case 'shipping':
        return 'Orig. Shipping Picture (JPG)'

      default:
        return 'Orig. Picture (JPG)'
    }
  }

  return 'Error'
}

export const buildText = (picture, type) => {
  switch (type) {
    case PICTURE_TYPES.C3_BIG:
      return 'Email Picture (JPG)'

    case PICTURE_TYPES.C3_THUMBNAIL:
      return 'Thumbnail Picture (JPG)'

    case PICTURE_TYPES.ORIGINAL_CROPPED:
      if (picture && picture.source && picture.source === 'designer') {
        return 'Designer Picture (JPG)'
      }

      return 'Cropped Picture (JPG)'

    case PICTURE_TYPES.ORIGINAL_JPG:
      return originalText(picture)

    case PICTURE_TYPES.ORIGINAL_RAW:
      return 'Orig. Photo Station Picture (RAW)'

    case PICTURE_TYPES.TIF_DESIGNER:
      return 'Designer Picture (TIF)'

    default:
      return 'Error'
  }
}

export const buildPopupText = (picture, type) => {
  return `Download ${buildText(picture, type)}`
}
